/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ContractBulkActionType } from './contractBulkActionType.model';


export interface ContractBulkActionListItem { 
    actionType?: ContractBulkActionType;
    countAll?: number;
    countAttachments?: number;
    countFailed?: number;
    countSuccess?: number;
    id?: number;
    resultFileSize?: number;
    state?: string;
    timeCreated?: string;
    timeDone?: string;
    timeStarted?: string;
    visible?: boolean;
}
export namespace ContractBulkActionListItem {
}


